import { render } from "./DrawingCreatePage.vue?vue&type=template&id=3d99126c"
import script from "./DrawingCreatePage.vue?vue&type=script&lang=js"
export * from "./DrawingCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__